import { html } from 'lit';
import { User } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-user')
export class PdsIconUser extends PdsIcon {
  @state()
  icon = User;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
